"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_PRODUCT = void 0;
var client_1 = require("@apollo/client");
var SimpleProductFragment_1 = require("../fragments/SimpleProductFragment");
exports.ADD_PRODUCT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AddProduct($input: AddProductInput!) {\n    addProduct(input: $input) {\n      product {\n        ...SimpleProduct\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AddProduct($input: AddProductInput!) {\n    addProduct(input: $input) {\n      product {\n        ...SimpleProduct\n      }\n    }\n  }\n  ", "\n"])), SimpleProductFragment_1.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1;
